import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, color = 'primary' }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success-50 text-success border-success-100';
      case 'warning':
        return 'bg-warning-50 text-warning border-warning-100';
      case 'error':
        return 'bg-error-50 text-error border-error-100';
      case 'primary':
      default:
        return 'bg-primary-50 text-primary border-primary-100';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-text-muted';
  };

  return (
    <div className="card p-6 hover:shadow-lg transition-layout">
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-lg ${getColorClasses()}`}>
          <Icon name={icon} size={24} strokeWidth={2} />
        </div>
        {change && (
          <div className={`flex items-center space-x-1 ${getChangeColor()}`}>
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={16} 
            />
            <span className="text-sm font-body-medium">{change}</span>
          </div>
        )}
      </div>
      
      <div>
        <h3 className="text-2xl font-heading-semibold text-text-primary mb-1">
          {value}
        </h3>
        <p className="text-sm text-text-secondary font-body-normal">
          {title}
        </p>
      </div>
    </div>
  );
};

export default MetricCard;